import React from "react";
import { CASE_STUDIES } from "@/lib/mockData";
import { ArrowUpRight } from "lucide-react";

const CaseStudies = () => {
  return (
    <section id="case-studies" className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">Case Studies</p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-zinc-50"
            data-testid="case-studies-heading"
          >
            Real campaigns. Real outcomes.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {CASE_STUDIES.map((c) => (
            <article
              key={c.brand}
              className={`relative rounded-2xl border border-white/8 bg-gradient-to-br ${c.color} p-7 lg:p-8 transition-all duration-300 hover:border-white/20 hover:-translate-y-1`}
              data-testid={`case-study-${c.brand.toLowerCase()}`}
            >
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-xs uppercase tracking-[0.18em] text-zinc-500">
                    {c.industry}
                  </div>
                  <div className="mt-1 text-2xl font-semibold tracking-tight text-zinc-50">
                    {c.brand}
                  </div>
                </div>
                <ArrowUpRight className="h-5 w-5 text-zinc-500 group-hover:text-blue-400 transition-colors" />
              </div>
              <p className="mt-4 text-sm text-zinc-300 leading-relaxed">{c.objective}</p>

              <div className="mt-7 grid grid-cols-3 gap-3 pt-6 border-t border-white/10">
                {[
                  { k: "Views", v: c.metrics.views },
                  { k: "ER", v: c.metrics.er },
                  { k: "ROI", v: c.metrics.roi },
                ].map((m) => (
                  <div key={m.k}>
                    <div className="text-lg font-semibold text-zinc-50 tracking-tight">{m.v}</div>
                    <div className="text-[11px] uppercase tracking-wider text-zinc-500 mt-0.5">
                      {m.k}
                    </div>
                  </div>
                ))}
              </div>

              <button className="mt-6 text-xs text-blue-300 hover:text-blue-200 inline-flex items-center gap-1">
                View Case Study <ArrowUpRight className="h-3 w-3" />
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
